import { getApiErrorMessage } from './get-api-error-message';

const DEFAULT_MESSAGE = '取消訂單失敗，請稍後再試';

/**
 * 將取消訂單的 API 錯誤訊息轉為中文。
 *
 * `isOrderCancelable` 已在前端擋掉這三種情況，按鈕不會出現；這裡處理的是
 * race condition — 頁面載入後、使用者按下確認前，訂單狀態才變成已完成／已取消／
 * 已出貨。對映字串取自 Medusa 2.19.0 的 cancelOrderWorkflow 驗證步驟。
 */
export function getOrderCancelErrorMessage(error: unknown): string {
  const apiMessage = getApiErrorMessage(error, '');

  // 訂單已完成（Medusa 2.14.0 #14874 新增的 guard）
  if (apiMessage.includes('Cannot cancel a completed order')) {
    return '訂單已完成，無法取消';
  }

  // 訂單已被取消
  if (apiMessage.includes('has been canceled')) {
    return '訂單已經取消過了';
  }

  // 仍有未取消的出貨單
  if (apiMessage.includes('must be canceled before canceling an order')) {
    return '訂單已出貨，無法直接取消，請聯繫客服';
  }

  return apiMessage || DEFAULT_MESSAGE;
}
